import Endpoint from 'modules/reports/orm/Endpoint'
import Model from 'modules/reports/orm/Model'
import Response from 'modules/reports/orm/Response'

export default class ListEndpoint<RequestT, T extends Model, MetaT = {}> extends Endpoint<
  RequestT,
  T[],
  MetaT
> {
  model: typeof Model

  process(response: Response<T[], MetaT>): T[] {
    return this.model.newArray(response.data) as T[]
  }
}
